import { css } from 'linaria';

export const BannerAdLabelStyles = css`
  position: absolute;
  bottom: 8px;
  left: 8px;
`;
